import React from 'react'

function GuideReg() {
  return (
    <div>GuideReg</div>
  )
}

export default GuideReg